import { ESTADO_STOCK } from "../common/Constants";

export default {
  data: {
    data: {
      basicInfoSchema: {
        carga_basica: {
          _name: 'Carga básica',
          disponible: {
            name: 'Tipo de unidad',
            required: true,
            options: ["FISICO", "A DEUDA"],
            default: "FISICO",
            type: 'enum',
            disabledByState: {
              Facturado: true,
            },
          },
          branch_office_id: {
            name: 'Sucursal',
            required: false,
            type: 'AsyncSelectObj',
            endpoint: '/abms/branch_office/Car_lot/',
          },
          licensee: {
            name: 'Licenciatario',
            required: false,
            disabled:true,
            type: 'text',
          },
          owner_id: {
            name: 'Concesionario Dueño',
            required: false,
            type: 'AsyncSelectObj',
            endpoint: '/abms/car_lot/product_owners',
            disabledByState: {
              Facturado: true,
            }
          },
          origen: {
            name: 'País de Origen',
            type: 'AsyncSelectCountries',
            required: false,
            disabledByState: {
              Facturado: true,
            }
          },
          idColor: {
            name: 'Color',
            required: false,
            type: 'AsyncSelectObjOptionsId',
            disabledByState: {
              Facturado: true,
            }
          },
          vin: {
            name: 'VIN',
            required: false,
            type: 'text',
            disabledByState: {
              Facturado: true,
            },
          },
          location_id: {
            name: 'Ubicación',
            required: false,
            type: 'AsyncSelectObj',
            endpoint: "/abms/location"
          },
          purchase_date: {
            name: 'Fecha de compra',
            required: false,
            type: 'date',
            dateTo: {
              until: "TODAY"
            },
            disabledByState: {
              Facturado: true,
            }
          },
          stock_days: {
            name: 'Días de stock',
            required: false,
            type: 'text',
            disabled: true
          },
        },
        seguimiento: {
          _name: 'Seguimiento',
          estado: {
            name: 'Estado',
            required: true,
            options: [
              {label: ESTADO_STOCK.ACTIVO, disabled: false},
              {label: ESTADO_STOCK.PENDIENTE, disabled: false},
              {label: ESTADO_STOCK.NO_A_LA_VENTA, disabled: false}, 
              {label: ESTADO_STOCK.RESERVADO, disabled: true}, 
              {label: ESTADO_STOCK.RESERVADO_SV, disabled: true}, 
              {label: ESTADO_STOCK.FACTURADO, disabled: true}], //este array de objetos es dependiente de objectOptions//
            objectOptions: true, //solo utilizable para opciones con formato de array de objetos//
            default: "Activo",
            type: 'enum',
            disableConditions: [ESTADO_STOCK.RESERVADO, ESTADO_STOCK.RESERVADO_SV, ESTADO_STOCK.FACTURADO], //Parámetro que se utiliza para condicionar la habilitación del select en schemaProcessing a través de la función isDisabledCondition
            disabledByState: {
              Facturado: true,
            }
          },
          offer_number: {
            name: 'Número de oferta',
            required: false,
            type: 'number',
            disabled: true
          },
          offer_date: {
            name: 'Fecha de oferta',
            required: false,
            type: 'date',
            disabled: true
          },
          prioridad: {
            name: 'Asignación prioritaria',
            required: false,
            type: 'trueBoolean',
            disabledByState: {
              Facturado: true,
            }
          },
          certPago: {
            name: 'Certificado de pago',
            required: false,
            default: undefined,
            type: 'trueBoolean',
            disabledByState: {
              Facturado: true,
            }
          },
          observaciones: {
            name: 'Observación',
            required: false,
            type: 'textarea',
          },
          patente: {
            name: 'Dominio',
            required: false,
            type: 'text',
            disabledByState: {
              Facturado: true,
            }
          },
          fecha_patente: {
            name: 'Fecha de dominio',
            required: false,
            type: 'date',
            disabledByState: {
              Facturado: true,
            }
          },
          bill_date: {
            name: 'Fecha de factura',
            required: false,
            type: 'date',
            disabledByState: {
              Facturado: true,
            }
          },
          bill_number: {
            name: 'Número de factura',
            required: false,
            type: 'number',
            disabledByState: {
              Facturado: true,
            }
          },
        }
      },
    },
  },
}
